import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

import { ErrorCodeEnum } from './error-codes.enum';

export function isValidationError(error: HttpErrorResponse) {
  return (
    error.status === HttpStatusCode.BadRequest &&
    error.error.errorCode === ErrorCodeEnum.VALIDATION_FAILED
  );
}
